import React from 'react';
import '../style/applicationsAndPolicies.css';
import '../style/dots.css';
import {isAragUser, isSolicitorUser} from "../helpers/functions";
import moment from "moment";
import {LEGAL_ADVICE_TEXT, POLICYHOLDER_TEXT,UI_LIB_TABLE_VIEW_OPTIONS} from "../helpers/variables";
import CenteredDots from "./General/centeredDots";
import { Link, useHistory } from "react-router-dom";
import {Table,FormGroup,Button,CheckboxInput,AutoSuggestSearch} from 'arag-ui-lib';


const commonStyle = { whiteSpace: 'normal', wordWrap: 'break-word' };

const applyCommonStyle = (columns) => {
  return columns.map(column => ({
    ...column,
    style: { ...commonStyle, ...(column.style || {}) }  // Apply common style, keeping any custom styles intact
  }));
};

const agentTableColumns = [
	{propertyName: "solicitorReference", header: `${LEGAL_ADVICE_TEXT} Reference`},
	{propertyName: "aragReference", header: "ARAG Reference"},
	{propertyName: "clientName", header: `${POLICYHOLDER_TEXT} Name`},
	{propertyName: "caseTypeName", header: "Case Type"},
	{propertyName: "subCaseTypeName", header: "Sub Case Type"},
	{propertyName: "date", header: "Submission Date", formatter: (row) => moment(row.lastEditedAt).format("DD/MM/YYYY")},
	{propertyName: "policyStatus", header: "Application Status"}
];

  const userUiLibTableColumns = [
	{propertyName: "solicitorReference", header: `${LEGAL_ADVICE_TEXT} Reference`},
	{propertyName: "aragReference", header: "ARAG Reference"},
	{propertyName: "solicitorFirm", header: `${LEGAL_ADVICE_TEXT} Firm`},
	{propertyName: "caseTypeName", header: "Case Type"},
	{propertyName: "subCaseTypeName", header: "Sub Case Type"},
	{propertyName: "date", header: "Submission Date", formatter: (row) => moment(row.lastEditedAt).format("DD/MM/YYYY")},
	{propertyName: "policyStatus", header: "Application Status", formatter: (row) => { return row.policyStatus === "Referred" ? row.policyStatus + ' to ' + row.referredToName : row.policyStatus;}},
	{propertyName: "agentName", header: "Created by"},
	{propertyName: "readByArag", header: "Read by ARAG", formatter: (row) => row.readByArag ? 'Read' : 'Unread'},
  ];

const ApplicationsAndPolicies = (props) => {	
	  const history = useHistory();

	  const columns = isAragUser(props.userRoles)
	  ? applyCommonStyle(userUiLibTableColumns)
	  : applyCommonStyle(agentTableColumns);

	const statusOptions = props.applicationStatuses
		.filter(item => item.name !== 'Draft')
		.map(item => ({
			machineName: item.machineName,
			value: item.name,
			label: item.name
		}));

	const statusOptionsForSolicitor = props.applicationStatuses
		.map(item => ({
			machineName: item.machineName,
			value: item.name,
			label: item.name
		}));

	const solicitorUserColleaguesOptions = props.solicitorUsers.map(user => ({
		value: user.userId,
		label: `${user.forename} ${user.surname}`
	}));

	return (
		<div className="row">
			<div className="col-sm-12 applicationsAndPolicies-wrapper">
				<div className="row">
					<h2 className="col-sm-12 applicationsAndPolicies-h2">Applications / Policies</h2>
				</div>
				{isAragUser(props.userRoles)?
				<Link className={"btn btn-primary btn-xs sharp white"} to={"/new-application"} >
               <span>Create New Application </span>
           		</Link>:null}
				<form className="form-horizontal applicationsAndPolicies-top-wrapper" onSubmit={evt=>{evt.preventDefault(); props.HandleInputChange('selectedSuggestions', props.Store.suggestions)}}
					data-testid='application-list-filters'>
					{(isSolicitorUser(props.userRoles) && props.isAgentAllowedToSeeAllFirmApplications) && (
						<FormGroup
							labelSize="col-sm-2"
							inputSize="col-sm-7"
							label="Firm agents"
							variant="multiSelect"
							inputProps={{
								options:solicitorUserColleaguesOptions.map(firm => ({value: firm.value, label: firm.label})),
								onChange: props.handleSolicitorUsersFirmsFilterChange,
								value: props.Store.selectedSolicitorUsers,
								placeholder:"Quick search"
							}}
							formGroupTestId="application-list-filter-firm-agents"
					 	/>				
					)}					
					{(isAragUser(props.userRoles)) && (
						<FormGroup
							labelSize="col-sm-2"
							inputSize="col-sm-7"
							label={`${LEGAL_ADVICE_TEXT} firms`}
							variant="multiSelect"
							inputProps={{
								options:props.lawsysFirms.map(firm => ({value: firm.id, label: firm.name})),
								onChange: props.handleSolicitorFirmsFilterChange,
								value: props.Store.selectedSolicitorFirms,	
								placeholder:"Quick search"
							}}
							formGroupTestId="application-list-filter-solicitor-firms"
					 	/>
					)}						
					{(isAragUser(props.userRoles)) && (
						<FormGroup
							labelSize="col-sm-2"
							inputSize="col-sm-7"
							label={`${LEGAL_ADVICE_TEXT} users`}
							variant="multiSelect"
							inputProps={{
								options:props.getSolicitorUsersForMultipleSelect(),
								onChange: props.handleSolicitorUsersFirmsFilterChange,
								value: props.Store.selectedSolicitorUsers,
								placeholder:"Quick search"
							}}
							formGroupTestId="application-list-filter-solicitor-users"
					 	/>
					)}
					<FormGroup
						labelSize="col-sm-2"
						inputSize="col-sm-7"
						label="Statuses"
						variant="multiSelect"
						inputProps={{
							options:props.UserRole !== 'Solicitor'? statusOptions:statusOptionsForSolicitor,
							onChange: props.handleStatusesFilterChange,
							value: props.Store.selectedStatuses,
							placeholder:"Quick search"
						}}
						formGroupTestId="application-list-filter-statuses"
					/>
					<FormGroup
						labelSize="col-sm-2"
						inputSize="col-sm-7"
						label="Case types"
						variant="multiSelect"
						inputProps={{
							options:props.caseTypesOptions,
							onChange: props.handleCaseTypesFilterChange,
							value: props.Store.selectedCaseTypes,
							placeholder:"Quick search"
						}}
						formGroupTestId="application-list-filter-case-types"
					/>
					<FormGroup
						labelSize="col-sm-2"
						inputSize="col-sm-7"
						label="Sub case types"
						variant="multiSelect"
						inputProps={{
							options:props.subCaseTypesOptions,
							onChange: props.handleSubCaseTypesFilterChange,
							value: props.Store.selectedSubCaseTypes,
							placeholder:"Quick search"
						}}
						formGroupTestId="application-list-filter-sub-case-types"
					/>
					<AutoSuggestSearch
						labelSize="col-sm-2"
						inputSize="col-sm-7"
						label="Search"						
						suggestions={props.suggestions}
						onSuggestionsFetchRequested={props.onSuggestionsFetchRequested}
						onSuggestionsClearRequested={props.onSuggestionsClearRequested}
						getSuggestionValue={props.getSuggestionValue}
						renderSuggestion={props.renderSuggestion}
						inputProps={props.inputProps}
						onSuggestionSelected={props.onSuggestionSelected}
						handleAutosuggestButton={props.HandleAutosuggestButton}
						themes ={{
							container: "ui-agents-list-action-autoSuggest-container",
							input:"ui-applicationsAndPolicies-autosuggest",
							suggestionsContainer: "ui-applicationsAndPolicies-autosuggest-suggestionsContainer",
							suggestionsList: "ui-applicationsAndPolicies-autosuggest-suggestionsList",
							suggestion: "ui-applicationsAndPolicies-autosuggest-suggestion",
							suggestionHighlighted:"ui-applicationsAndPolicies-autosuggest-suggestion-highLighted"
						}}
						autoSuggestTestId="application-list-filter-auto-suggest"
							/>
					<div className="form-group">
						<div className="col-sm-2"></div>
						{
							props.UserRole !== "Solicitor"?
								<div className="col-sm-3">
									<CheckboxInput
										name="includeDraft"
										onChange={(evt) => {props.HandleInputChange(evt.target.name, !props.Store.includeDraft)}}
										label="Display draft applications"
										checked={props.Store.includeDraft}
										checkboxInputTestId="checkbox-input-include-draft"
									/>
								</div>
								:
								null
						}
					</div>
                    <div className={"form-group"}>
                        <div className={"col-sm-6 col-sm-offset-2"}>
							<Button 
								variant="primary" label="Filter" 
								arrowDirection="right" onClick={props.handleFilterClick}
							    style={{ marginRight: '10px' }} buttonTestId="button-filter"
							/>	
							<Button
								variant="quaternary"  label="Clear filters" 
								arrowDirection="right"  onClick={props.clearApplicationsAndPoliciesFilters} 
								buttonTestId="button-clear-filters"
							/>
                        </div>
                    </div>
				</form>
                {
                    ((props.Store.fetching === true) && (props.Store.applications.length === 0)) ?
                        <div className="form-group">
                           <CenteredDots/>
                        </div>
                        :
                        props.Store.applications.length > 0?
						<div data-testid="application-list-table">
						<Table
						  striped
						  loading={props.Store.fetching}
						  columns={columns}
						  data={props.Store.applications}
						  pageSize={parseInt(props.Store.selectedView)}
						  totalRecords={props.Store.totalRecords}
						  totalPages={props.Store.totalBoxes}
						  page={props.Store.page}
						  hasActions
						  actions={[
							{
							  key: 'details',
							  label: 'Details',
							  callback: (row) => "/application-and-policies/application-policy/" + row.id,
							  isActionLink: true,
							  arrowDirection:"right"
							},
						  ]}
						  pageSizeOptions={UI_LIB_TABLE_VIEW_OPTIONS}
						  onPageSizeChange={props.onPageSizeChange}
						  goAtPrevious={props.goAtPrevious}
						  goAtNext={props.goAtNext}
						  goAtStart={props.goAtStart}
						  goAtEnd={props.goAtEnd}
						  goAtPage={props.goAtPage}
						  withVerticalAlignedHeader
						/>
					  </div>					  
                            :
                            <div className="text-center">
                                <span>No application to show.</span>
                            </div>
                }
			</div>
		</div>
	)
};


export default ApplicationsAndPolicies ;
